import React from "react";

import { highlightSubstringPropTypes } from "./HighlightSubstring.propTypes";
import { HighlightSubstringProps } from "./HighlightSubstring.types";

/*
 * The HighlightSubstring React component emphasizes a portion of string by wrapping part of the
 * string with a <strong> element.
 *
 * Example:
 * value: "The brown fox jumps"
 * substring: "fox"
 *
 * Return
 * "The brown <strong>fox</strong> jumps"
 */

export const HighlightSubstring = (props: HighlightSubstringProps) => {
  const { substring, value } = props;

  return renderString();

  function renderString() {
    let content: React.ReactNode = value;

    if (typeof value === "string" && typeof substring === "string" && substring !== "") {
      const lowercaseItem = value.toLowerCase();
      const matchIndex = lowercaseItem.lastIndexOf(substring.toLowerCase());

      if (matchIndex !== -1) {
        content = (
          <>
            {value.substring(0, matchIndex)}
            <strong>{value.substring(matchIndex, matchIndex + substring.length)}</strong>
            {value.substring(matchIndex + substring.length)}
          </>
        );
      }
    }

    return content;
  }
};

HighlightSubstring.propTypes = highlightSubstringPropTypes;
